import { createFileRoute } from "@tanstack/react-router";
import { ArticleCard } from "@/components/article-card";
import { useSuspenseQuery } from "@tanstack/react-query";
import { fetchArticles, fetchSettings } from "@/lib/api";

export const Route = createFileRoute("/cerpen/")({
  loader: async ({ context: { queryClient } }) => {
    const [articles, settings] = await Promise.all([
      queryClient.ensureQueryData({ queryKey: ["articles"], queryFn: fetchArticles }),
      queryClient.ensureQueryData({ queryKey: ["settings"], queryFn: fetchSettings }),
    ]);
    return { articles, settings };
  },
  head: ({ loaderData }) => {
    const { settings } = loaderData as any;
    const siteName = settings?.site_name || "Lihar Aksara";
    const canonicalUrl = "https://liharaksara.web.id/cerpen";
    const title = `Katalog Cerpen — ${siteName}`;
    const description = `Jelajahi kumpulan cerita pendek pilihan di ${siteName}.`;

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { property: "og:type", content: "website" },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: Cerpen,
});

function Cerpen() {
  const { data: allArticles } = useSuspenseQuery({ queryKey: ["articles"], queryFn: fetchArticles }) as any;
  const articles = allArticles?.filter((a: any) => a.type === "SHORTSTORY") || [];

  return (
    <div className="container-editorial py-16 md:py-32">
      <div className="mb-24">
        <div className="text-[10px] uppercase tracking-[0.5em] text-accent font-bold mb-6">
          Fiksi Pendek
        </div>
        <h1 className="font-serif text-5xl md:text-8xl font-medium tracking-tight leading-[0.95] mb-8">
          Kumpulan Cerpen
        </h1>
        <p className="text-xl md:text-2xl text-muted-foreground font-serif max-w-3xl italic leading-relaxed">
          Kumpulan cerita pendek yang merangkum fragmen kehidupan, imajinasi, dan emosi dalam narasi yang padat namun mendalam.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-x-12 md:gap-y-20">
        {articles?.map((a: any) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>

      {!articles?.length && (
        <div className="py-40 text-center border border-dashed border-border rounded-3xl bg-secondary/10">
          <p className="font-serif text-2xl text-muted-foreground italic">Belum ada cerpen yang diterbitkan...</p>
        </div>
      )}
    </div>
  );
}
